import { Trans, useLingui } from '@lingui/react/macro';

import FileUpload from '@/components/FileUpload';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const ProofOfAuthenticity = () => {
  const { t } = useLingui();

  const { article, view, errors, proofOfAuthenticityMedia } = useArticleContext();

  return (
    <FileUpload
      uploadData={{
        type: 'proof-of-authenticity',
        articleId: article.id,
      }}
      ariaLabel={t({
        id: 'article.form.proof-of-authenticity.aria-label',
        message: 'Upload proof of authenticity',
      })}
      type="file"
      label={
        <>
          <Trans id="article.form.proof-of-authenticity.label">Proof of authenticity</Trans>
          {!view.warranty.fields.proofOfAuthenticity.required && <OptionalLabel />}
        </>
      }
      media={proofOfAuthenticityMedia}
      error={
        errors.warranty?.missingProofOfAuthenticity
          ? t({
              id: 'article.form.proof-of-authenticity.error',
              message: 'A proof of authenticity is required',
            })
          : undefined
      }
      deleteWithApi
      size="large"
      withQrCode
    />
  );
};
